import axios from "axios";

const cleanParam = (value) => {
  if (value == null) return "";
  const text = String(value).trim();
  if (!text || text === "null" || text === "undefined") return "";
  return text;
};

export const downloadJobWorkDraftReport = async (inputs = {}) => {
  const urlParams = new URLSearchParams();
  const from = cleanParam(inputs.from);
  const to = cleanParam(inputs.to);
  const year = cleanParam(inputs.year);
  const month = cleanParam(inputs.month);

  if (from) urlParams.set("from", from);
  if (to) urlParams.set("to", to);
  if (year) urlParams.set("year", year);
  if (month) urlParams.set("month", month);

  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const query = urlParams.toString();
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/list-job-work-draft-report-excel${
        query ? `?${query}` : ""
      }`,
      config
    );
    const result = data?.data?.result;
    if (typeof result === "string" && /^https?:\/\//i.test(result.trim())) {
      return result.trim();
    }
    return null;
  } catch (error) {
    console.log(error);
    if (error?.response?.data?.message) {
      throw error;
    }
    return null;
  }
};
